import React from 'react';

const TermsAndConditions = ({ isChecked, onCheckboxChange, onShowRules }) => (
    <div className="terms-container">
        <label htmlFor="termsCheckbox" className="terms-label">
            <input
                type="checkbox"
                id="termsCheckbox"
                checked={isChecked}
                onChange={onCheckboxChange}
            />
            Я прочитал <a href="#" onClick={(e) => { e.preventDefault(); onShowRules(); }} className="rules-link">правила</a> и принимаю условия сервиса.
        </label>
    </div>
);

export default TermsAndConditions;
